import { ARTIST_STORAGE_KEY } from '@/constants'
import client, { uploadFile } from '@/utils/client'
import urls from '@/utils/urls'
import storage from '@/utils/storage'

var defaultState = {
  artist: storage.load(ARTIST_STORAGE_KEY) || {}
}

export const getters = {
  artist: state => state.artist,
  hasPayoutMethod: state => !!state.artist.stripe_account_id,
  artistName: state => state.artist.name || (state.artist.profile ? state.artist.profile.name || state.artist.profile.username : null),
  artistAvatar: state => state.artist.avatar_image || '/static/img/default-avatar.jpg',
  artistHero: state => state.artist.hero_image || '/static/img/default-hero.jpg'
}

export const mutations = {
  setArtist (state, payload) {
    state.artist = payload
    storage.save(ARTIST_STORAGE_KEY, state.artist)
  },
  clearArtist (state) {
    state.artist = {}
    storage.remove(ARTIST_STORAGE_KEY)
  },
  setFollowerCount (state, count) {
    state.artist.follower_count = count
    storage.save(ARTIST_STORAGE_KEY, state.artist)
  }
}

export const actions = {
  async createArtist ({ commit, dispatch }, data) {
    const resp = await client.post(urls.artist.list(), data)
    commit('setArtist', resp.data)
    // we intentionally want to return the artist data here, after the user data is refreshed (to reflect the fact
    // they're an artist now)
    await dispatch('profile/getCurrentUser', null, {root: true})
    return resp.data
  },
  async getCurrentArtist ({ commit, dispatch, state }) {
    const resp = await dispatch('profile/getCurrentUser', null, {root: true})
    if (!resp || !resp.artist) return null
    commit('setArtist', resp.artist)
    return resp.artist
  },
  async updateArtist ({ commit, state }) {
    const resp = await client.put(urls.artist.detail(state.artist.id), state.artist)

    commit('setArtist', resp.data)
    return resp.data
  },
  async setFollowerCount ({ commit }, count) {
    commit('setFollowerCount', count)
  },
  async setAvatar ({ dispatch }, { file }) {
    await uploadFile(urls.artist.avatar(), file)
    return dispatch('getCurrentArtist')
  },

  async deleteAvatar ({ dispatch }) {
    await client.delete(urls.artist.avatar())
    return dispatch('getCurrentArtist')
  },

  async setHero ({ dispatch }, { file }) {
    await uploadFile(urls.artist.hero(), file)
    return dispatch('getCurrentArtist')
  },

  async deleteHero ({ dispatch }) {
    await client.delete(urls.profile.hero())
    return dispatch('getCurrentArtist')
  },

  async getArtist (ctx, { id }) {
    const resp = await client.get(urls.artist.detail(id))
    return resp.data
  },

  async reportArtist ({ dispatch }, { id, reason, url }) {
    return client.post(urls.artist.report(id), { reason, url })
  }
}

export default {
  namespaced: true,
  state: defaultState,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/artist.js